import { render, staticRenderFns } from "./BtnPrestacaoContasFinalDocumentos.vue?vue&type=template&id=41a4a900"
import script from "./BtnPrestacaoContasFinalDocumentos.vue?vue&type=script&lang=js"
export * from "./BtnPrestacaoContasFinalDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports